import { registerChatEmbed } from '@/core/chat/export';
import { DataHistoryChatEmbed } from '@/modules/calendar/export';

registerChatEmbed('data-history', DataHistoryChatEmbed);
